import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import ScrollProgress from "./components/ScrollProgress";
import Hero from "./components/Hero";
import BrandMarquee from "./components/BrandMarquee";
import ScrollVideo from "./components/ScrollVideo";
import Services from "./components/Services";
import Process from "./components/Process";
import ParallaxBanner from "./components/ParallaxBanner";
import Garage from "./components/Garage";
import Formations from "./components/Formations";
import About from "./components/About";
import Testimonials from "./components/Testimonials";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import PaymentSuccess from "./components/PaymentSuccess";
import PaymentCancel from "./components/PaymentCancel";
import MentionsLegales from "./components/legal/MentionsLegales";
import PolitiqueConfidentialite from "./components/legal/PolitiqueConfidentialite";
import { Toaster } from "./components/ui/toaster";

const Home = () => {
  return (
    <div className="App">
      <div className="noise-overlay fixed inset-0 z-[100]" />
      <ScrollProgress />
      <Navbar />
      <main>
        <Hero />
        <BrandMarquee />
        <ScrollVideo />
        <Services />
        <Process />
        <ParallaxBanner />
        <Garage />
        <Formations />
        <About />
        <Testimonials />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/payment/success" element={<PaymentSuccess />} />
        <Route path="/payment/cancel" element={<PaymentCancel />} />
        <Route path="/mentions-legales" element={<MentionsLegales />} />
        <Route path="/politique-confidentialite" element={<PolitiqueConfidentialite />} />
      </Routes>
      <Toaster />
    </BrowserRouter>
  );
}

export default App;
